<template>
    <div class="lo section">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .lo.section {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        // overflow: auto;
        max-width: 100%;
        transform: $transition;

        .lo.aside.is-show + & {
            padding-left: $interval-l;

            @include media('mobile') {
                padding-left: 0;
            }
        }
    }
</style>
